import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { BaseComponent } from 'src/app/shared/components/baseComponent';
import { LayoutService } from '../../services/layout.service';
import { SearchService } from '../../services/search.service';

@Component({
  selector: 'vex-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent extends BaseComponent implements OnInit, OnDestroy {
  show$ = this.layoutService.searchOpen$;
  searchCtrl = new UntypedFormControl();

  @ViewChild('searchInput', { static: true }) input: ElementRef;

  constructor(private layoutService: LayoutService, private searchService: SearchService) {
    super();
  }

  ngOnInit() {
    this.searchService.isOpenSubject.next(true);
    this.searchCtrl.valueChanges.pipe(this.untilDestroyed()).subscribe((value) => this.searchService.valueChangesSubject.next(value));

    this.show$
      .pipe(
        filter((show) => show),
        this.untilDestroyed()
      )
      .subscribe(() => this.input.nativeElement.focus());
  }

  close() {
    this.layoutService.closeSearch();
    this.searchCtrl.setValue(undefined);
    this.searchService.isOpenSubject.next(false);
  }

  search() {
    this.searchService.submitSubject.next(this.searchCtrl.value);
    this.close();
  }

  ngOnDestroy(): void {
    this.layoutService.closeSearch();
    this.searchCtrl.setValue(undefined);
    this.searchService.isOpenSubject.next(false);
  }
}
